export const LOGIN = 'auth/LOGIN';
export const LOGIN_REQUIRE_2FA = 'auth/LOGIN_REQUIRE_2FA';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';

export const SSO = 'auth/SSO';
export const SSO_SUCCESS = 'auth/SSO_SUCCESS';
export const SSO_ERROR = 'auth/SSO_ERROR';

export const LOGOUT = 'auth/LOGOUT';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';

export const FETCH_MY_USER = 'auth/FETCH_MY_USER';
export const FETCH_MY_USER_SUCCESS = 'auth/FETCH_MY_USER_SUCCESS';
export const FETCH_MY_USER_ERROR = 'auth/FETCH_MY_USER_ERROR';

export const SET_LOGIN_DESTINATION = 'auth/SET_LOGIN_DESTINATION';

export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'auth/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'auth/FORGOT_PASSWORD_ERROR';

export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'auth/RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'auth/RESET_PASSWORD_ERROR';

export const CHANGE_PASSWORD = 'auth/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'auth/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'auth/CHANGE_PASSWORD_ERROR';

export const VERIFY_TOKEN = 'auth/VERIFY_TOKEN';
export const VERIFY_TOKEN_SUCCESS = 'auth/VERIFY_TOKEN_SUCCESS';
export const VERIFY_TOKEN_ERROR = 'auth/VERIFY_TOKEN_ERROR';

export const VERIFY_RESET_CODE = 'auth/VERIFY_RESET_CODE';
export const VERIFY_RESET_CODE_SUCCESS = 'auth/VERIFY_RESET_CODE_SUCCESS';
export const VERIFY_RESET_CODE_ERROR = 'auth/VERIFY_RESET_CODE_ERROR';

export const INIT_2FA = 'auth/INIT_2FA';
export const INIT_2FA_SUCCESS = 'auth/INIT_2FA_SUCCESS';
export const INIT_2FA_ERROR = 'auth/INIT_2FA_ERROR';

export const ENABLE_2FA = 'auth/ENABLE_2FA';
export const ENABLE_2FA_SUCCESS = 'auth/ENABLE_2FA_SUCCESS';
export const ENABLE_2FA_ERROR = 'auth/ENABLE_2FA_ERROR';
